<template>
  <div id="runningMission">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>ミッションの選択</b></p>
    <div v-if="isAssigned">
      <div v-if="!done">
        <div >
          <p>ミッション完遂か妨害を選択し，決定して下さい．<br>※レジスタンスはどちらを選んでも遂行となります．</p>
          <v-container fluid>
            <v-row justify="center">
              <div class="agree">
                <agreeButton v-if="voted=='true'" v-on:pushed="setVote('true')" label="完遂" active="true" />
                <agreeButton v-else v-on:pushed="setVote('true')" label="完遂" active="false" />
              </div>

              <div class="disagree">
                <disagreeButton v-if="voted=='false'" v-on:pushed="setVote('false')" label="妨害" active="true" />
                <disagreeButton v-else v-on:pushed="setVote('false')" label="妨害" active="false" />
              </div>
            </v-row>
          </v-container>
          <!-- <v-btn v-if="voted=='true'" class="agree" v-on:click="setVote('true')" large color="primary" min-width=90><b>遂行</b></v-btn>
          <v-btn v-else class="agree" v-on:click="setVote('true')" outlined large color="primary" min-width=90>遂行</v-btn>

          <v-btn v-if="voted=='false'" class="disagree" v-on:click="setVote('false')" large color="error" min-width=90><b>裏切</b></v-btn>
          <v-btn v-else class="disagree" v-on:click="setVote('false')" outlined large color="error" min-width=90>裏切</v-btn> -->
        </div>

        <div class="send-button">
          <sendButton v-if="voted=='true'||voted=='false'" v-on:pushed="vote" label="決定" active="true"/>
          <sendButton v-else label="決定" active="false"/>
        </div>

      </div>
      <div v-else>
        <p>ミッションメンバーの選択を待っています．</p>
      </div>
    </div>
    <div v-else>
      <p>ミッションの選択を待っています．</p>
    </div>
  </v-card>

  <missionMemberCard />

  </div>
</template>
<script>
import agreeButton from '@/components/gameUiComponents/AgreeButton.vue'
import disagreeButton from '@/components/gameUiComponents/DisagreeButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
import missionMemberCard from '@/components/gameComponents/cardComponents/MissionMemberCard.vue'

export default {
  name: "runnningMission",
  plops: [],
  components: {
    agreeButton,
    disagreeButton,
    sendButton,
    missionMemberCard,
  },
  data() {
    return {
      socket: this.$store.state.webSocket.socket,
      roomId: this.$store.getters.roomId,
      userName: this.$store.getters.userName,
      userId: this.$store.getters.userId,
      isAssigned: false,
      voted: '',
      done: false,
    };
  },
  computed: {
    role() {
      return this.$store.state.userInfo.role
    },
    assignedUsers() {
      return this.$store.state.missionInfo.assignedUsers
    },
    isSpy() {
      if (this.role == 'spy'){
        return true
      }else {
        return false
      }
    },
    snackNum() {
      return this.$store.state.gameInfo.snackNum
    }
  },
  methods: {
    setVote(vote){
      this.voted = vote
    },
    vote() {
      console.log(this.voted)
      // this.done = true
      if (this.isSpy){
        this.$emit("send-request", {"action": "deliver-mission", "roomId": this.roomId, "userId" : this.userId, "data": {"deliver": this.voted}})
      }else {
        this.$emit("send-request", {"action": "deliver-mission", "roomId": this.roomId, "userId" : this.userId, "data": {"deliver": 'true'}})
      }
      if (this.snackNum > 0){
        this.done = false
      }
    }
  },
  created (){
    console.log(this.assignedUsers)
    for (var i in this.assignedUsers){
      if (this.assignedUsers[i].id == this.userId){
        this.isAssigned = true
      }
    }
    this.done = false

    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}

      if (res.state != "running-mission"){
        self.$emit("show-text", {state: "running-mission", text: "ミッションが開始されました．"})

        var nextState = "runningMission"
        if (res.state == "running-mission"){
          nextState = "runningMission"
        }else if (res.state == "wait-watcher"){
          nextState = "waitWatcher"
        }else if (res.state == "mission-completed"){
          nextState = "missionCompleted"
        }

        self.$emit("proceed-state", nextState)
        self.done = false
      }
      else {
        self.done = true
      }
    }
  }
}
</script>
<style>
#runningMission .send-button {
  padding-top: 12px;
  padding-bottom: 12px;
}
#runningMission .agree {
  margin-right: 12px;
  margin-left: 12px;
}
#runningMission .assigned-table{
  align-items: center;
  flex-direction: column;
  display: inline-block;
  text-align:center;
  min-width: 200px
}
</style>
